module.exports = __webpack_public_path__ + "static/media/Sunset2.6bb76597.jpeg";